export function getValueKey(item: unknown): string {
    if (!item || typeof item !== 'object') return String(item ?? '')
    const stringKeys = Object.keys(item).filter(key => typeof item[key] === 'string').sort()
    const numberKeys = Object.keys(item).filter(k => typeof item[k] === 'number' || typeof item[k] === 'boolean')
    const stringValue = stringKeys.length ? item[stringKeys[0]] : ''
    const numberValue = numberKeys.length ? item[numberKeys[0]] : ''
    return `${stringValue} ${numberValue}`.trim()
}

export function getTooltip(item: unknown): string {
    if (!item || typeof item !== 'object') return String(item ?? '')

    return `<ul style="margin:0; padding:0; list-style:none;">` +
        Object.entries(item)
            .map(([key, value]) => `<li><strong>${key}:</strong> ${value}</li>`)
            .join('') +
        `</ul>`
}
